<template>
	<div class="search-picker" :class="[externalClass]">
		<!-- <p class="search-title" :class="{ 'required': required }">{{title}}</p> -->
		<slot></slot>
		<div class="search-input" :class="{ 'show-picker': showPicker }">
			<input
				v-if="inputType == 'input'"
				class="text-overflow"
				:class="{ 'is-disabled': disabled }"
				type="text"
				ref="searchInput"
				:disabled="disabled"
				autocomplete="off"
				@focus="handleInputFocus"
				@blur="handleInputBlur"
				v-model.trim="value"
				:placeholder="placeholder"
				:maxlength="maxlength"
				@input="handleChange"
			/>
			<textarea
				v-else
				class="text-area"
				rows="1"
				ref="searchTextarea"
				autocomplete="off"
				@focus="handleInputFocus"
				@blur="handleInputBlur"
				v-model.trim="value"
				:placeholder="placeholder"
				:maxlength="maxlength"
				@input="handleChange"
			/>
			<i class="iconfont icon-shenhebutongguo icon-error icon-company-error"></i>
		</div>
		<div class="picker-list" v-show="showPicker" @touchstart.stop @touchmove="handleTouchmove">
			<ul>
				<li
					@click="handleSelect(item)"
					class="item text-overflow"
					v-for="item in listData"
					:key="item.id"
					v-html="item.title"
				></li>
			</ul>
		</div>
	</div>
</template>

<script>
import { debounce, throttle, getUserInfo } from '@/utils/api';
import { appointment } from '@/fetch/interface';
export default {
	props: {
		inputType: {
			type: String,
			default: 'input'
		},
		placeholder: {
			type: String,
			default: '请输入'
		},
		externalClass: String,
		externalValue: String,
		externalMessage: Object,
		disabled: {
			type: Boolean,
			default: false
		},
		maxlength: {
			type: Number,
			default: 100
		}
	},
	data() {
		return {
			isShow: false,
			value: '',
			list: [],
			touchmove: false
		};
	},
	computed: {
		userInfo() {
			return getUserInfo();
		},
		listData() {
			const reg = new RegExp(this.value, 'g');
			return this.list.map(item => {
				return {
					...item,
					title: this.value
						? item.fullname.replace(reg, `<span style="color: #3F5BD6;">${this.value}</span>`)
						: item.fullname
				};
			});
		},
		showPicker() {
			return this.isShow && this.listData.length;
		}
	},
	watch: {
		externalValue: {
			handler: function (newVal) {
				this.value = newVal || '';
			},
			immediate: true
		}
	},
	mounted() {
		this.handleChange = debounce(this.handleChange, 300, false);
		this.handleTouchmove = throttle(this.handleTouchmove, 300);

		document.addEventListener('touchstart', event => {
			this.isShow = false;
		});
	},
	methods: {
		handleInputFocus() {
			this.touchmove = false;
			this.handleChange();
		},
		handleInputBlur() {
			if (this.touchmove) {
				return;
			}
			setTimeout(() => {
				this.isShow = false;
			}, 0);
			this.$emit('blur');
		},
		handleSelect(item) {
			this.$emit('select', { id: item.id, name: item.fullname, externalMessage: this.externalMessage });
			this.value = item.fullname;
			this.isShow = false;
			this.list = [];
			setTimeout(this.handlerTextHeight, 100);
		},
		handleChange() {
			this.handlerTextHeight();
			this.isShow = true;
			this.$emit('input', { name: this.value, externalMessage: this.externalMessage });
			if (!this.value.length) {
				return (this.list = []);
			}
			if (this.value.length > 50) {
				this.isShow = false;
				return;
			}

			this.$axios
				.post(appointment.allInstitutionList, {
					pagestart: 0,
					pagenum: 20,
					fullname: this.value
				})
				.then(res => {
					if (res?.rows?.length) {
						this.list = res.rows.map(item => {
							return {
								...item,
								title: item.fullname
							};
						});
					}
				});
		},
		handleTouchmove() {
			if (this.touchmove) {
				return;
			}
			this.touchmove = true;
			this.$refs.searchInput && this.$refs.searchInput.blur();
		},
		handlerTextHeight() {
			let textarea = this.$refs.searchTextarea;
			if (textarea) {
				textarea.style.height = 'auto';
				textarea.style.height = textarea.scrollHeight + 'px';
			}
		}
	}
};
</script>

<style lang="less" scoped>
.search-picker {
	position: relative;
	width: 100%;
	display: flex;
	align-items: center;
	.search-title {
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 400;
		font-size: 30px;
		line-height: 48px;
		color: var(--color-Text-2);
	}
	.search-input {
		position: relative;
		flex: 1;
		height: 100%;

		input {
			width: 100%;
			height: 100%;
			font-size: 0.14rem;
			border: none;
		}
	}
	.icon-error {
		position: absolute;
		top: 50%;
		right: 0;
		transform: translateY(-50%);
		display: none;
		font-size: 0.12rem;
		color: #eb5149;
	}
	.icon-company-error {
		right: 0.2rem;
	}
	.show-picker:after {
		content: '';
		position: absolute;
		bottom: -5px;
		left: 0;
		z-index: 2;
		width: 0px;
		height: 0px;
		border: 10px solid #ffffff;
		border-top-color: transparent;
		border-left-color: transparent;
		border-right-color: transparent;
	}
	.picker-list {
		position: absolute;
		top: 100%;
		left: 50%;
		transform: translateX(-50%);
		z-index: 1;
		width: 3.47rem;
		max-height: 2.15rem;
		padding: 0 0.1rem;
		background-color: #fff;
		box-shadow: 0px 2px 44px rgba(0, 0, 0, 0.06);
		ul {
			max-height: 2.17rem;
			overflow-y: auto;
		}
		.item {
			height: 0.43rem;
			line-height: 0.43rem;
			font-size: 0.15rem;
			color: #333;
			.tag {
				color: var(--color-Brand1-1);
			}
		}
		.item + .item {
			border-top: 1px solid var(--color-Line-1);
		}
	}

	.is-disabled {
		color: #ccc;
	}
	.text-area {
		width: 100%;
		text-align: right;
		border: none;
		resize: none;
		overflow-y: hidden;
		&::placeholder {
			color: #c5c5c5;
			font-weight: normal;
		}
	}
}
</style>
